import gql from 'graphql-tag';

const QUERY_ALTERNATIVES = gql`
  query Alternatives($input: AlternativeHomecardsInput!) {
    alternativeHomecards(input: $input) {
      checked
      currencyIsoCode
      firstAvailableDate
      id
      isInstantBooking
      noSecurityDeposit
      isFavorite
      mainPhotoUrl
      reviews {
        ratingAverage
      }
      title
      description
      type
      url
      features
      area
      offers {
        discountType
        discountValue
      }
      allowsPermanentContract
      numberOfBathrooms
      isBestChoice
      landlordId
      so
      photoIds
      otherPropertyPhotoIds
      displayPrice
      billsIncluded
      hasOffer
    }
  }
`;

export const getAlternativesQuery = client => input =>
  client.query({
    query: QUERY_ALTERNATIVES,
    variables: {
      input
    }
  });

export default getAlternativesQuery;
